<style>
  .lastDsc {
    background-color: #ff9c95 !important;
  }
  .customerIgnore {
    background-color: #d6ff95 !important;
  }
</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">صندوق نامه</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> شناسه  </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomerId"
            name="Search_code_LetterRequestCustomerId" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> شماره نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_code_LetterRequestCustomer"
            name="Search_code_LetterRequestCustomer" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> موضوع نامه </label>
          <input type="text" class="form-control" [(ngModel)]="Search_persianDate_LetterRequestCustomer"
            name="Search_persianDate_LetterRequestCustomer" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام مشتری </label>
          <input type="text" class="form-control" [(ngModel)]="Search_customer_LetterRequestCustomer"
            name="Search_customer_LetterRequestCustomer" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> پیام </label>
          <select [(ngModel)]="Search_Order_LetterRequestCustomer" name="Search_Order_LetterRequestCustomer"
            class="custom-select">
            <option value="">همه موارد</option>
            <option *ngFor="let item of Search_Order_LetterRequestCustomer_List" [value]="item">{{item}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> وضیعت </label>
          <select [(ngModel)]="Search_Section_LetterRequestCustomer" name="Search_Section_LetterRequestCustomer"
            class="custom-select">
            <option value="">همه موارد</option>
            <option *ngFor="let item of Search_Section_LetterRequestCustomer_List" [value]="item">{{item}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> نوع نامه </label>
          <select [(ngModel)]="Search_Readed_LetterRequestCustomer" name="Search_Readed_LetterRequestCustomer"
            class="custom-select">
            <option value="">همه موارد</option>
            <option value="1">خوانده شده</option>
            <option value="2">جدید</option>
          </select>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_LetterRequestCustomer()" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1" style="font-weight: bolder;">تعداد نامه ها : {{(DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_code_LetterRequestCustomer:'code'
            |filter:Search_code_LetterRequestCustomerId:'letterCode'
            |filter:Search_customer_LetterRequestCustomer:'customer').length}} </label>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1" style="font-weight: bolder;">تعداد نامه های خوانده نشده :
            {{(DataList_LetterRequestCustomer
            |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
            |filter:Search_code_LetterRequestCustomer:'code'
            |filter:Search_code_LetterRequestCustomerId:'letterCode'
            |filter:'2':'readedId'
            |filter:Search_customer_LetterRequestCustomer:'customer').length}} </label>
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>نامه</th>
              <th>نوع</th>
              <th>مشتری</th>
              <th>موضوع</th>
              <th>فرستنده</th>
              <th>وضیعت</th>
              <th>تاریخ ارجاع</th>
              <th>پیوست</th>
              <th>پیام</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
          |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
          |filter:Search_customer_LetterRequestCustomer:'customer'
          |filter:Search_code_LetterRequestCustomer:'code'
          |filter:Search_code_LetterRequestCustomerId:'letterCode'
          |filter:Search_Readed_LetterRequestCustomer:'readedId'
          |filter:Search_Order_LetterRequestCustomer:'lastOrder'
          |filter:Search_Section_LetterRequestCustomer:'lastSection'
          | paginate
                  : {
                      id: 'DataList_FeildTable',
                      itemsPerPage: 10,
                      currentPage: page,
                      totalItems: (DataList_LetterRequestCustomer
                      |filter:Search_persianDate_LetterRequestCustomer:'subject_name'
                      |filter:Search_code_LetterRequestCustomer:'code'
                      |filter:Search_code_LetterRequestCustomerId:'letterCode'
                      |filter:Search_Readed_LetterRequestCustomer:'readedId'
                      |filter:Search_customer_LetterRequestCustomer:'customer'
                      |filter:Search_Section_LetterRequestCustomer:'lastSection'
                      |filter:Search_Order_LetterRequestCustomer:'lastOrder').length
                    }
          " [ngClass]="{'lastDsc': item.lastDsc,'customerIgnore': item['customerIgnore']}">
              <td>
                <p *ngIf="item.readed">{{DataList_LetterRequestCustomer.indexOf(item)+1}}</p>
                <span *ngIf="!item.readed" class="badge badge-pill badge-info float-right mt-1">جدید</span>
              </td>
              <td>{{item.letterCode}}</td>
              <td>{{item.code}}</td>
              <td>{{item.letterType}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.subject_name}}</td>
              <td>{{item.lastSender}}</td>
              <td>{{item.lastSection}}</td>
              <td>{{item.lastDate}}</td>
              <td>
                <i *ngIf="item.peyvaset" class="fa fa-check" style="color: green;"></i>
                <i *ngIf="!item.peyvaset" class="fa fa-times" style="color: red;"></i>
                <i *ngIf="item.sms" class="fa fa-envelope" style="color: blue;"></i>
                <i *ngIf="item.codePeygiri" class="fa fa-money" title="{{item.codePeygiri}}" style="color: blue;"></i>

              </td>
              <td>{{item.lastOrder}}</td>
              <td>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='رسید امانت'"
                  [routerLink]="['/LetterRequestCustomerPreOrder',{id:item.id}]"><i class="fa fa-edit"></i> مشاهده
                </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='نامه وارده'"
                  [routerLink]="['/LetterRequestCustomerDraftForm',{id:item.id}]"><i class="fa fa-edit"></i>
                  مشاهده </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='نامه صادره'"
                  [routerLink]="['/LetterRequestCustomerForm',{id:item.id}]"><i class="fa fa-edit"></i> مشاهده
                </a>
                <a target="_blank" class="btn btn-info" *ngIf="item.letterType=='درخواست کالیبراسیون'"
                  [routerLink]="['/LetterRequestCustomerCalibration',{id:item.id}]"><i class="fa fa-edit"></i>
                  مشاهده </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>